import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { ComboService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalViewCombo extends React.Component<Props> {

	state = {
		product: null,
		products: []
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ComboService.admin.view({
			product_id: this.props.item?.id
		});
		this.setState({
			product: res.product,
			products: res.products || []
		});
	}
	
	render() {
		const product: any = this.state.product;

		return (
			<div id="modal-view-combo">
				<div className="row row-title-blue">
					<div className="col-2">
						<button className="btn-close" onClick={ () => this.props.onClose() }>
							<img src={ ArrowLeftWhite } />
						</button>
					</div>
					<div className="col-8">
						<h4>{ product?.name } - Productos Incluidos</h4>
					</div>
				</div>
				{
					this.state.products.length > 0 && (
						<table className="table">
							<tr className="tr-header">
								<th style={{ width: '70%' }}>Producto</th>
								<th style={{ width: '30%' }} className="text-right">Presentación</th>
							</tr>
							{
								this.state.products.map((item: any, index: number) => {
									return (
										<tr>
											<td>{ item?.name }</td>
											<td className="text-right">
												{ item?.presentation?.name }
											</td>
										</tr>
									)
								})
							}
						</table>
					)
				}				
				{
					this.state.products.length == 0 && (
						<p className="no-items">No se han agregado productos al combo</p>
					)
				}
				<div className="text-center">
					<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalViewCombo;